const events = {
	CartUpdated: new Event("catalog.cart.updated")
};

export default events;



// WEBPACK FOOTER //
// ./src/common/events.ts